import {spotheroPatch} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {type InventorySpaces} from 'api/inventory/inventory.types';
import {type RawApiResponse} from 'api/api.types';

interface UpdateDefaultInventoryParams {
    facilityId: number;
    spaces: number;
}

type UpdateDefaultInventoryResponse = InventorySpaces;
type UpdateDefaultInventoryRawResponse =
    RawApiResponse<UpdateDefaultInventoryResponse>;

/**
 * Updates a given faciliity's inventory with a new default number of available spaces
 * @param facilityId - The facility id.
 * @param spaces - The number of spaces to set as available inventory
 *
 * @see '/api/v1/facilities/{facilityId}/default-inventory/'
 */
const updateDefaultInventory = async ({
    facilityId,
    spaces,
}: UpdateDefaultInventoryParams) => {
    try {
        const {data} = await spotheroPatch<UpdateDefaultInventoryRawResponse>(
            `facilities/${facilityId}/default-inventory/`,
            {spaces}
        );

        return data?.data?.spaces;
    } catch (err) {
        sendSentryException(err);

        throw err;
    }
};

export default updateDefaultInventory;
